import Api from "./HandleErrorApi";

class RegionApi {
    api = new Api();

    getCurrentDB() {
        return this.api.get('regions/db');
    }

    async getRegionsList() {
        return await this.api.get('regions/list')
    }
}

export default new RegionApi();
